import axios, { AxiosResponse } from 'axios';
import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from '../../constants';
import { BriefClassificationResponse, IntentClassification } from '../../api';
import { logger } from '../../utils/logger';

export const handleClassificationError = ({
    requestType,
    userInput,
    errorMessage,
    isAborted = false,
    isTimeout = false,
}: {
    requestType: string;
    userInput?: string;
    errorMessage?: string;
    isTimeout?: boolean;
    isAborted?: boolean;
}) => {
    if (isAborted) {
        stats.count(`${METRICS_PREFIX}.${requestType}`, 'canceled');
        return;
    }
    const error = new Error(`Failed while classifying ${requestType}, ${isTimeout ? ' - Timeout' : ''}`);
    logger.error(error, {
        ...(errorMessage && { cause: errorMessage }),
        ...(userInput && { userInput }),
    });
    stats.count(`${METRICS_PREFIX}.${requestType}`, isTimeout ? 'timeout' : 'error');
};

export const isInvalidIntent = (intent?: IntentClassification) => !!intent && intent !== 'valid_intent';

export const checkClassificationResponseIsValid = ({
    classificationResponse,
    isAborted,
    requestType,
}: {
    classificationResponse: AxiosResponse<BriefClassificationResponse>;
    isAborted: boolean;
    requestType: string;
}): boolean => {
    if (!classificationResponse?.data || isAborted) {
        handleClassificationError({
            requestType,
            isTimeout: !isAborted,
            isAborted,
            errorMessage: `${requestType} response is null`,
        });
        return false;
    }
    return true;
};

export const handlePollingError = ({
    error,
    pollingId,
    inspectedField,
}: {
    error: any;
    inspectedField: keyof BriefClassificationResponse;
    pollingId: string;
}): boolean => {
    if (error.response?.status >= 400) {
        logger.error(`Classification polling error - ${error.response?.status}`, { error, inspectedField, pollingId });
        stats.count(`${METRICS_PREFIX}.classification_polling`, error.response?.status.toString());
        if (error.response?.status >= 500) {
            throw error;
        }

        return true;
    }

    if (axios.isCancel(error)) {
        logger.info('Request was cancelled', { cause: error, inspectedField });
        return true;
    }

    throw error;
};

export const handleGetBuyerDataError = ({
    requestType,
    errorMessage,
    isAborted = false,
    isTimeout = false,
}: {
    requestType: string;
    userInput?: string;
    errorMessage?: string;
    isTimeout?: boolean;
    isAborted?: boolean;
}) => {
    if (isAborted) {
        stats.count(`${METRICS_PREFIX}.${requestType}`, 'canceled');
        return;
    }
    const error = new Error(`Failed while getting Buyer Data ${requestType}, ${isTimeout ? ' - Timeout' : ''}`);
    logger.error(error, {
        ...(errorMessage && { cause: errorMessage }),
    });
    stats.count(`${METRICS_PREFIX}.${requestType}`, isTimeout ? 'timeout' : 'error');
};
